import React, { useEffect, useState } from 'react';
import { Add, Remove } from '@material-ui/icons';

const PAGE_HEIGHT_PX = 1120; // Simulated height of an A4 page
const LINE_HEIGHT_PX = 20; // Estimated line height
const MAX_LINES_PER_PAGE = Math.floor((PAGE_HEIGHT_PX - 64) / LINE_HEIGHT_PX); // Margin

const splitTextIntoPages = (text) => {
  const lines = text.split('\n');
  const pages = [];

  for (let i = 0; i < lines.length; i += MAX_LINES_PER_PAGE) {
    pages.push(lines.slice(i, i + MAX_LINES_PER_PAGE).join('\n'));
  }

  return pages;
};

const styles = {
  container: {
    height: '68vh',
    display: 'flex',
    flexDirection: 'column',
  },
  zoomControls: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(0,0,0,0.2)',
    borderRadius: '4px 4px 0 0',
  },
  button: {
    cursor: 'pointer',
    color: '#4b5563',
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '0 8px',
    minWidth: '40px',
    textAlign: 'center',
  },
  documentArea: {
    flex: 1,
    overflow: 'auto',
    padding: '0',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  pagesContainer: {
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '15px 0',
  },
  page: {
    background: 'white',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 0 12px rgba(0,0,0,0.2)',
    width: '92%',
    maxWidth: '800px',
    height: `${PAGE_HEIGHT_PX}px`,
    marginBottom: '2rem',
    fontFamily: 'monospace',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    lineHeight: `${LINE_HEIGHT_PX}px`,
    pointerEvents: 'none',
    userSelect: 'none',
    overflow: 'hidden',
  },
};

const TxtViewer = ({ url, onLoad = () => null }) => {
  const [zoom, setZoom] = useState(1);
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(url)
      .then((res) => {
        const contentType = res.headers.get('Content-Type');
        if (!res.ok || !contentType.includes('text/plain')) {
          throw new Error('Invalid file or not a .txt file');
        }
        return res.text();
      })
      .then((text) => {
        setPages(splitTextIntoPages(text));
        onLoad();
      })
      .catch((err) => {
        setError('The file could not be loaded.');
        console.error('Error loading .txt:', err);
      });
  }, [url]);

  return (
    <div style={styles.container}>
      {/* Zoom Controls */}
      <div style={styles.zoomControls}>
        <button onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))} style={styles.button}>
          <Remove />
        </button>
        <span style={styles.text}>{Math.round(zoom * 100)}%</span>
        <button onClick={() => setZoom((z) => Math.min(3, z + 0.1))} style={styles.button}>
          <Add />
        </button>
      </div>

      {/* Document Viewer */}
      <div style={styles.documentArea}>
        {error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          <div
            style={{ transform: `scale(${zoom})`, transformOrigin: 'top center', width: '100%' }}
          >
            <div style={styles.pagesContainer}>
              {pages.map((pageContent, index) => (
                <div key={index} style={styles.page}>
                  {pageContent}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TxtViewer;
